/* -------------------------------------------------------------------------- */
/*                                   Config                                   */
/* -------------------------------------------------------------------------- */

import { uuid } from '@utils/functions';

interface Step {
	key: string;
	label: string;
}

export const STEPS: Step[] = [
	{
		key: uuid(),
		label: 'productions.mintProductionStepper.step1',
	},
	{
		key: uuid(),
		label: 'productions.mintProductionStepper.step2',
	},
	{
		key: uuid(),
		label: 'productions.mintProductionStepper.step3',
	},
];
